import styled from '@emotion/styled';
import { Link } from 'gatsby';

/**
 * Breadcrumb component - Matches Figma design (node-id=3-12864)
 * Format: <Level 1 Menu> / <Current Page>
 * Font: Inter Semi Bold, 14px
 */
export const BreadcrumbWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 15px;
  max-width: 800px;
  width: 100%;
  
  margin-bottom: var(--gap-4x, 20px);
  font-family: var(--font-family-primary, 'Inter', sans-serif);
  font-size: var(--font-size-sm, 14px);
  font-weight: 500;
  line-height: 1.3;

  @media (min-width: 993px) {
    margin-left: -15px;
  }
`;

export const BreadcrumbItem = styled(Link)`
  color: var(--color-info-quaternary);
  text-decoration: none;
  transition: color var(--transition-fast, 0.15s ease);

  &:hover {
    color: var(--color-info-tertiary);
  }
`;

export const BreadcrumbSeparator = styled.span`
  color: var(--color-info-quaternary);
`;

export const BreadcrumbCurrent = styled.span`
  color: var(--color-info);
`;

/**
 * Page heading with left border accent
 * Updated to match Figma design
 */
export const StyledHeading = styled('h1')`
  font-family: var(--font-family-primary, 'Inter', sans-serif);
  font-size: var(--font-size-3xl, 28px);
  line-height: var(--line-height-tight, 1.3);
  font-weight: 600;
  padding: 0 var(--gap-3x, 15px);
  padding-left: 0;
  flex: 1;
  margin-top: 0;
  padding-top: 0;
  color: var(--color-info);
`;

/**
 * Edit button container
 */
export const Edit = styled('div')`
  padding: var(--gap-2x, 10px) var(--gap-3x, 15px);
  text-align: right;

  a {
    font-family: var(--font-family-primary, 'Inter', sans-serif);
    font-size: var(--font-size-sm, 14px);
    font-weight: 500;
    line-height: 1em;
    text-decoration: none;
    color: var(--color-info-secondary);
    border: 1px solid var(--color-border-secondary);
    cursor: pointer;
    border-radius: var(--radius-md, 6px);
    transition: all var(--transition-fast, 0.15s ease);
    background-color: var(--color-bg-container);
    box-shadow: var(--shadow-header);
    height: 30px;
    padding: var(--gap-1x, 5px) var(--gap-3x, 15px);

    &:hover {
      background-color: var(--color-bg-surface);
      border-color: var(--color-border);
    }
  }
`;

/**
 * Main content wrapper
 * Max width: 800px (inner content area)
 */
export const StyledMainWrapper = styled.div`
  max-width: 800px;
  color: var(--color-info-secondary);
  font-family: var(--font-family-primary, 'Inter', sans-serif);
`;
